module.exports = __webpack_public_path__ + "img/aumentar.f8cfa8f5.svg";